import Controller from "./pricing.controller";
import template from "./pricing.html";

const pricing = {
  template,
  controller: Controller,
};

export default pricing;



// WEBPACK FOOTER //
// ./src/pages/pricing/pricing.component.js